'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("fileImage", function (security, urlUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<img ng-src="{{filePath}}">',
    link: function link($scope, $el, $attrs) {
      $scope.filePath = null;
      $attrs.$observe("url", function (url) {
        $scope.filePath = urlUtils.addParams(url, security.getTokens());
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/fileImage.js
// module id = 2938
// module chunks = 13